import { ThingsToDoResponse } from '@/types'
import { logger } from '@/logging/Logger'
import { AgentConfiguration } from '@big-red-group/storefront-common-checkout'

const log = logger()

export const formatRedirectLinkLabels = (label: string) => {
  return label.replaceAll('-', ' ').toLowerCase()
}

export async function getThingsToDoResponse(
  agentConfiguration: AgentConfiguration,
  categoryUrlSegment: string,
  subcategoryUrlSegment: string | undefined
): Promise<ThingsToDoResponse> {
  try {
    const searchParams = {
      categoryPath: categoryUrlSegment,
      ...(subcategoryUrlSegment ? { subcategoryPath: subcategoryUrlSegment } : {}),
    }

    const query = new URLSearchParams({ ...agentConfiguration, ...searchParams })
    const res = await fetch(`${process.env.NEXT_PUBLIC_LOKI_BASE_URL}/storefront-resources/things-to-do?${query}`, {
      method: 'GET',
    })

    if (!res.ok) throw new Error(res.statusText)
    return await res.json()
  } catch (e) {
    log.info('Error getting things-to-do', {}, e as Error)
    return Promise.resolve({ error: true })
  }
}
